import React from "react";
import PaginaLocal from "../components/PaginaLocal";
import Perguntas from "../components/Perguntas";
import { Itens, OutrosServicos, LinkSeta } from "../components/Blocos";
import { locais } from "../components/data/locais";
import { servicos } from "../components/data/servicos";

const local = locais.orleans;
const metodo = servicos.software.secoes.find((secao) => secao.numerada);

const blocos = [
  { chave: "apresentacao", rotulo: local.apresentacao.rotulo, titulo: local.apresentacao.titulo, texto: local.apresentacao.texto, conteudo: <Itens secao={local.apresentacao} /> },
  { chave: "servicos", rotulo: "Serviços", titulo: "O que fazemos em Orleans", conteudo: <OutrosServicos /> },
  { chave: "metodo", rotulo: metodo.rotulo, titulo: metodo.titulo, azul: true, conteudo: <Itens secao={metodo} claro /> },
  { chave: "perguntas", rotulo: "Dúvidas", titulo: "Perguntas sobre a Hawx em Orleans", conteudo: <Perguntas perguntas={local.perguntas} /> },
  {
    chave: "vizinhas",
    rotulo: local.vizinhas.rotulo,
    titulo: local.vizinhas.titulo,
    conteudo: (
      <div className="xl:text-center">
        <p className="text-xl leading-relaxed text-gray-700 xl:w-2/3 xl:mx-auto">{local.vizinhas.texto}</p>
        <LinkSeta href="/onde-atendemos">Ver o mapa das cidades atendidas</LinkSeta>
      </div>
    ),
  },
];

const Orleans = () => <PaginaLocal local={local} blocos={blocos} />;

export default Orleans;
